import Tab from "@Components/Tabs/Tab";
import Tabs from "@Components/Tabs/Tabs";
import TabsList from "@Components/Tabs/TabsList";
import appendWithString from "@Pages/Search/utils/appendWithString";
import Panel from "@Pages/Search/components/NearbySection/components/Panel";
import wrapperHOC from "@Utils/wrapperHOC";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import useTranslationHook from "hooks/useTranslationHook";
//

type NearbySectionType = {
  isDesktop?: boolean;
};

const NearbySection = ({ isDesktop = false }: NearbySectionType) => {
  const { cities, areas, universities } = useSelector(
    ({ propertyPageData }: AppState) => ({
      cities: propertyPageData?.nearbyData?.cities,
      areas: propertyPageData?.nearbyData?.areas,
      universities: propertyPageData?.nearbyData?.universities,
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();

  const SHOW_CITIES_TAB = cities && cities.length > 0;
  const SHOW_AREAS_TAB = areas && areas.length > 0;
  const SHOW_UNIVERSITIES_TAB = universities && universities.length > 0;
  const showNearbyLinks = Boolean(SHOW_CITIES_TAB || SHOW_AREAS_TAB || SHOW_UNIVERSITIES_TAB);

  if (!showNearbyLinks) {
    return <></>;
  }

  return (
    <Tabs defaultValue="cities" renderAllPanels>
      <TabsList removeMargin>
        {SHOW_CITIES_TAB && (
          <Tab value="cities" dataTestId="nearbyCities-tabs">
            {appendWithString(
              t("propertypage.components.nearbysection.cities"),
              t("propertypage.components.nearbysection.nearbysuffix"),
              false,
            )}
          </Tab>
        )}
        {SHOW_AREAS_TAB && (
          <Tab value="areas" dataTestId="nearbyAreas-tabs">
            {appendWithString(
              t("propertypage.components.nearbysection.localities"),
              t("propertypage.components.nearbysection.nearbysuffix"),
              false,
            )}
          </Tab>
        )}
        {SHOW_UNIVERSITIES_TAB && (
          <Tab value="universities" dataTestId="nearbyUniversities-tabs">
            {appendWithString(
              t("propertypage.components.nearbysection.universities"),
              t("propertypage.components.nearbysection.nearbysuffix"),
              false,
            )}
          </Tab>
        )}
      </TabsList>

      {SHOW_CITIES_TAB && (
        <Panel
          name="cities"
          data={cities}
          isDesktop={isDesktop}
          dataTestId="cities"
          headingText={t("propertypage.components.nearbysection.cities")}
        />
      )}
      {SHOW_AREAS_TAB && (
        <Panel
          name="areas"
          data={areas}
          isDesktop={isDesktop}
          dataTestId="areas"
          headingText={t("propertypage.components.nearbysection.localities")}
        />
      )}
      {SHOW_UNIVERSITIES_TAB && (
        <Panel
          name="universities"
          data={universities}
          isDesktop={isDesktop}
          dataTestId="universities"
          headingText={t("propertypage.components.nearbysection.universities")}
        />
      )}
    </Tabs>
  );
};

export default wrapperHOC(NearbySection, {
  componentName: "NearbySection-PropertyPage",
  showForChina: true,
  showForMiniProgram: false,
  showForApp: false,
});
